// extracted by mini-css-extract-plugin
module.exports = {"modal":"style_modal__21u1g","modalContent":"style_modalContent__WYEW5","modalBtn":"style_modalBtn__2iwZX"};